import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad är ett serveringstillstånd?";
const SHORT_ANSWER = "Ett serveringstillstånd är ett kommunalt beslut som ger dig rätt att servera alkoholdrycker mot betalning enligt 8 kap. alkohollagen (2010:1622).";

export const Route = createFileRoute("/fraga/vad-ar-serveringstillstand")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad är ett serveringstillstånd" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Serveringstillstånd krävs för all servering av spritdrycker, vin, starköl och andra jästa alkoholdrycker mot ersättning. Tillståndet utfärdas av den kommun där serveringsstället ligger och prövas mot personlig och ekonomisk lämplighet, lokalens utformning samt verksamhetens karaktär. Reglerna finns främst i 8 kap. alkohollagen."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/serveringstillstand", label: "Serveringstillstånd – komplett guide" }}
      related={[{"to": "/fraga/vem-behover-serveringstillstand", "label": "Vem behöver söka serveringstillstånd?"}, {"to": "/fraga/vilka-typer-av-serveringstillstand-finns", "label": "Vilka typer av serveringstillstånd finns?"}, {"to": "/fraga/vad-ar-skillnaden-mot-systembolaget", "label": "Vad skiljer gårdsförsäljning från Systembolaget?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad är ett serveringstillstånd?" },
      { name: "description", content: "Ett serveringstillstånd är ett kommunalt beslut som ger dig rätt att servera alkoholdrycker mot betalning enligt 8 kap. alkohollagen (2010:1622)." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-ar-serveringstillstand" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-ar-serveringstillstand" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-ar-serveringstillstand",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad är ett serveringstillstånd", url: "https://alkoholprovet.se/fraga/vad-ar-serveringstillstand" },
      ]),
    ],
  }),
});
